import React from "react";
import "./FaqMenuCard.css";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Box, Button, Paper } from "@material-ui/core";
import FaqMenuTypeList from "./FaqMenuTypeList";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

export default function FaqMenuCardTest(props) {
  const classes = useStyles();
  console.log("FaqMenuCardTest Entered");
  console.log("FAQ Data: ", props.onFaqMenuData);
  console.log(
    "FAQ Data to map: ",
    props.onFaqMenuData.BODY.details.data.collection.faq
  );

  let faqData = props.onFaqMenuData.BODY.details.data.collection;
  console.log("faqData collection: ", faqData);
  let faqUrl = props.onFaqMenuData.BODY.details.url;

  return (
    <React.Fragment>
      <div className="faq-menu-wrapper faq-menu-wrapper-bot faq-menu-wrapper-border faq-menu-width-70">
        <div className={classes.root}>
          <Paper>
            {faqData.faq.map((data, i) => (
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>
                    {data.question}
                  </Typography>
                </AccordionSummary>
                {/* Based on Types */}
                {data.targetType == "string" && (
                  <AccordionDetails>
                    <Typography>{data.answer}</Typography>
                  </AccordionDetails>
                )}
                {data.targetType == "list_string" && (
                //   <AccordionDetails>
                //     <Typography>{data.answer}</Typography>
                //   </AccordionDetails>
                <FaqMenuTypeList faqListData={data.answer}/>
                )}
                {data.targetType == "list_url" && (
                  <AccordionDetails>
                    <Typography>{data.answer}</Typography>
                  </AccordionDetails>
                )}
              </Accordion>
            ))}
          </Paper>
        </div>
        <Typography
          variant="caption"
          display="block"
          gutterBottom
          className="typography_link_center"
        >
          <Button variant="outlined" size="small" href={faqUrl} target="_blank">
            Link
          </Button>
        </Typography>
      </div>
    </React.Fragment>
  );
}
